import React, { useEffect, useState, useRef } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import FieldArea from "../../../../CustomComponents/FieldText";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import * as Yup from "yup";
import NumberInputBox from "../../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import CoverImages from "../CompanyFlow/CompanyFileUpload";

const formdatatomap = [
  {
    title: (<>Upload CV <AsteriskLabel /></>),
    name: "cv",
    placeholder: "Drag and drop or Browse file",
  },
  {
    title: (<>Are you looking for full time job? <AsteriskLabel /></>),
    name: "full_time_job",
    placeholder: "full_time_job",
  },
  // { title: "Category", name: "category_id", placeholder: 'Category' },
  {
    title: (<>Current job title <AsteriskLabel /></>),
    name: "current_job_title",
    placeholder: "Enter Title",
  },
  {
    title: (<>Preferred work location <AsteriskLabel /></>),
    name: "work_location",
    placeholder: "work_location",
  },
  {
    title: (<>Are you open for part time job? <AsteriskLabel /></>),
    name: "part_time",
    placeholder: "part_time",
  },
  {
    title: "Price per hour in $",
    name: "price_per_hour",
    placeholder: "Enter Price per hour",
  },
  {
    title: "Price per month in $",
    name: "price_per_month",
    placeholder: "Enter Price per month",
  },
  {
    title: (<>Preferred work location <AsteriskLabel /></>),
    name: "work_location2",
    placeholder: "work_location2",
  },
  {
    title: (<>Preferred working country <AsteriskLabel /></>),
    name: "working_country",
    placeholder: "working_country",
  },
];

const IAddCVPreferences = ({
  formData,
  setFormData,
  nextPage,
  previousPage,
}) => {
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [fulltime, setFulltime] = useState(formData?.full_time_job || 1);
  const [parttime, setPartTime] = useState(formData?.part_time || 1);
  const [country, setCountry] = useState("");
  const [selectCatgory, setselectCatgory] = useState(formData?.category_index1);
  const [selectCountry, setSelectCountry] = useState(
    formData?.working_country_index,
  );
  const formikRef = useRef(null);

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [image, setImage] = useState(null);
  const initialValues = {
    cv: formData?.cv,
    full_time_job: formData?.full_time_job || 1,
    category_id: formData?.category_id,
    current_job_title: formData?.current_job_title,
    work_location: formData?.work_location || 1,
    part_time: formData?.part_time || 1,
    price_per_hour: formData?.price_per_hour,
    price_per_month: formData?.price_per_month,
    working_country: formData?.working_country,
    work_location2: formData?.work_location2 || 1,
  };

  const validationSchema = Yup.object().shape({
    cv: Yup.mixed().required("CV is required"),
    full_time_job: Yup.number().required(
      "Please specify if you are looking for a full-time job",
    ),
    // // category_id: Yup.string().required('Category is required'),
    current_job_title: Yup.string().required("Current job title is required"),
    work_location: Yup.string().required("Work location is required"),
    part_time: Yup.number().required(
      "Please specify if you are open for part-time job",
    ),
    price_per_hour: Yup.number()
      .required("Price per hour is required")
      .positive("Price must be positive"),
    price_per_month: Yup.number()
      .required("Price per month is required")
      .positive("Price must be positive"),
    working_country: Yup.string().required(
      "Preferred working country is required",
    ),
    work_location2: Yup.string().required("Title is required"),
  });
  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    setCategory(skillsss);
  }, [skillsss]);

  useEffect(() => {
    setCountry(countrylist);
  }, [countrylist]);

  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (image == null && formData.cv != null) {
        setFormData((prevData) => ({
          ...prevData,
          ...values,
        }));

        nextPage();
        return;
      }

      const data = {
        ...values,
      };

      setFormData((prevData) => ({
        ...prevData,
        ...data,
      }));

      nextPage();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const handleCategoryChange = (selectedOption, formik) => {
    setselectCatgory(selectedOption);
    formik.setValues({
      ...formik.values,
      category_index1: selectedOption,
      category_id: selectedOption.value,
    });
  };

  const handleWorkingcountryChange = (selectedOption, formik) => {
    setSelectCountry(selectedOption);
    formik.setValues({
      ...formik.values,
      working_country_index: selectedOption,
      working_country: selectedOption.value,
    });
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const getValidationSchema = (values) => {
    if (fulltime == 1 && parttime == 1) {
      return Yup.object().shape({
        cv: Yup.mixed().required("CV is required"),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job",
        ),
        // category_id: Yup.string().required('Category is required'),
        current_job_title: Yup.string().required(
          "Current job title is required",
        ),
        work_location: Yup.string().required("Work location is required"),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job",
        ),
        price_per_hour: Yup.number()
          .required("Price per hour is required")
          .positive("Price must be positive"),
        price_per_month: Yup.number()
          .required("Price per month is required")
          .positive("Price must be positive"),
        working_country: Yup.string().required(
          "Preferred working country is required",
        ),
        work_location2: Yup.string().required("Title is required"),
      });
    } else if (fulltime == 1 && parttime !== 1) {
      return Yup.object().shape({
        cv: Yup.mixed().required("CV is required"),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job",
        ),
        // category_id: Yup.string().required('Category is required'),
        current_job_title: Yup.string().required(
          "Current job title is required",
        ),
        work_location: Yup.string().required("Work location is required"),
        working_country: Yup.string().required(
          "Preferred working country is required",
        ),
      });
    } else if (parttime == 1 && fulltime !== 1) {
      return Yup.object().shape({
        cv: Yup.mixed().required("CV is required"),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job",
        ),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job",
        ),
        price_per_hour: Yup.number()
          .required("Price per hour is required")
          .positive("Price must be positive"),
        price_per_month: Yup.number()
          .required("Price per month is required")
          .positive("Price must be positive"),
        work_location2: Yup.string().required(
          "Preferred work location is required",
        ),
        working_country: Yup.string().required(
          "Preferred working country is required",
        ),
      });
    } else if (parttime == 2 && fulltime == 2) {
      return Yup.object().shape({
        cv: Yup.mixed().required("CV is required"),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job",
        ),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job",
        ),
      });
    } else if (parttime !== 1 && fulltime !== 1) {
      return Yup.object().shape({
        cv: Yup.mixed().required("CV is required"),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job",
        ),
        // category_id: Yup.string().required('Category is required'),
        current_job_title: Yup.string().required(
          "Current job title is required",
        ),
        work_location: Yup.string().required("Work location is required"),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job",
        ),
        price_per_hour: Yup.number()
          .required("Price per hour is required")
          .positive("Price must be positive"),
        price_per_month: Yup.number()
          .required("Price per month is required")
          .positive("Price must be positive"),
        working_country: Yup.string().required(
          "Preferred working country is required",
        ),
        work_location2: Yup.string().required("Title is required"),
      });
    } else {
      return Yup.object().shape({
        cv: Yup.mixed().required("CV is required"),
        full_time_job: Yup.number().required(
          "Please specify if you are looking for a full-time job",
        ),
        part_time: Yup.number().required(
          "Please specify if you are open for part-time job",
        ),
      });
    }
  };

  return (
    <div>
      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            06/9 <span>CV & job preferences</span>
          </h6>
          <h2>Upload your resume and work preferences</h2>
          <p>Share Your resume and job preference</p>
        </div>
        <div className="col-lg-6   about-right add-cv">
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={(values) => getValidationSchema(values)}
            enableReinitialize
            innerRef={formikRef}
          >
            {(formik) => (
              <Form>
                { }
                <div>
                  {formdatatomap.map((prop, key) => {
                    if (prop.name == "full_time_job") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="margin-head">{prop.title}</h6>
                          <div className="checkbox-label">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="1"
                                checked={formik.values[prop.name] == "1"}
                                onChange={(e) => {
                                  setFulltime(1);
                                  formik.setFieldValue(prop.name, "1");
                                }}
                              />
                              <span className="checkmark">Yes</span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="2"
                                checked={formik.values[prop.name] == "2"}
                                onChange={(e) => {
                                  setFulltime(2);
                                  formik.setFieldValue(prop.name, "2");
                                }}
                              />
                              <span className="checkmark">No</span>
                            </label>
                          </div>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }
                    if (prop.name == "category_id") {
                      if (
                        prop.name == "category_id" &&
                        formik.values.full_time_job == 1
                      ) {
                        return (
                          <div className="form-group" key={key}>
                            <label>Category</label>
                            <ReactSelect
                              options={
                                Array.isArray(category) &&
                                category.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              placeholder="Select Category"
                              value={selectCatgory}
                              onChange={(options) => {
                                handleCategoryChange(options, formik);
                              }}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "current_job_title") {
                      if (
                        prop.name == "current_job_title" &&
                        formik.values.full_time_job == 1
                      ) {
                        return (
                          <FieldInput
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "work_location") {
                      if (
                        prop.name == "work_location" &&
                        formik.values.full_time_job == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="work-title">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="1"
                                  checked={formik.values[prop.name] == "1"}
                                />
                                <span className="checkmark">Virtual </span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="2"
                                  checked={formik.values[prop.name] == "2"}
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }

                    if (prop.name == "cv") {
                      return (
                        <>
                          <div key={key}>
                            <h6>{prop.title}</h6>
                            <CoverImages
                              formik={formik}
                              type={'single'}
                              name={prop?.name}
                              title={prop?.title}
                              allowAllDocs={true}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        </>
                      );
                    }

                    if (prop.name == "part_time") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="margin-head">{prop.title}</h6>
                          <div className="checkbox-label">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="1"
                                checked={formik.values[prop.name] == 1}
                                onChange={(e) => {
                                  setPartTime(1);
                                  formik.setFieldValue(prop.name, 1);
                                }}
                              />
                              <span className="checkmark">Yes</span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                name={prop.name}
                                value="2"
                                checked={formik.values[prop.name] == 2}
                                onChange={(e) => {
                                  setPartTime(2);
                                  formik.setFieldValue(prop.name, 2);
                                }}
                              />
                              <span className="checkmark">No</span>
                            </label>
                          </div>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }
                    if (prop.name == "price_per_hour") {
                      if (
                        prop.name == "price_per_hour" &&
                        formik.values.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            type={"number"}
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "price_per_month") {
                      if (
                        prop.name == "price_per_month" &&
                        formik.values.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            type={"number"}
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "work_location2") {
                      if (
                        prop.name == "work_location2" &&
                        formik.values.part_time == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="work-title">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="1"
                                  checked={formik.values[prop.name] == "1"}
                                />
                                <span className="checkmark">Virtual</span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  value="2"
                                  checked={formik.values[prop.name] == "2"}
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "working_country") {
                      if (
                        prop.name == "working_country" &&
                        (formik.values.part_time == 1 ||
                          formik.values.full_time_job == 1)
                      ) {
                        return (
                          <div className="form-group" key={key}>
                            <label>Preferred working country <AsteriskLabel /></label>
                            <ReactSelect
                              options={
                                Array.isArray(country) &&
                                country.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              placeholder="Select country"
                              value={selectCountry}
                              onChange={(options) => {
                                handleWorkingcountryChange(options, formik);
                              }}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }

                    if (prop.name == "about") {
                      return (
                        <FieldArea
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }

                    return (
                      <FieldInput
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  })}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div className="button-container">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button type="button" onClick={handleNextClick} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default IAddCVPreferences;
